import { useEffect, useRef } from 'react';

/**
 * This callback is helpful when you want to compare current value and previous one to check what's changed.
 */
export function usePreviousValue<T>(value: T): T | undefined {
  const prevValue = useRef<T | undefined>(undefined);

  useEffect(() => {
    prevValue.current = value;

    return () => {
      prevValue.current = undefined;
    };
  });

  return prevValue.current;
}
